module.exports = __webpack_public_path__ + "static/assets/855a0d7847380c26af17d003a964103f.png";